module.exports = __webpack_public_path__ + "static/3dgens-logo_480px_whiteall-0aca9343159ca206955412d0ff3f0c5a.png";